import React from 'react';

const Error = ({ message }) => {
  return (
    <div className="error-container">
      <h2>Error</h2>
      <p>{message || 'An error occurred while fetching snacks. Please try again later.'}</p>
      <button onClick={() => window.location.reload()}>Retry</button>
    </div>
  );
};

export default Error;
